module.exports = __webpack_public_path__ + "static/media/02.9b366ce5.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/dayup/home/02.png
// module id = 795
// module chunks = 0